import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke102aRequest, Sgke102aResponse, Sgke102aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke102aService {

  /**
   * コンストラクタ
   * @param {Sgke102aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke102aService
   */
  constructor(public service: Sgke102aService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * Sgke102aAPI実行
   *
   * @param {Sgke102aRequest} request
   * @return {*}  {Observable<Sgke102aResponse>}
   * @memberof UsedSgke102aService
   */
  public doSgke102a(request: Sgke102aRequest): Observable<Sgke102aResponse> {

    return this.service.sgke102aPost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE102A');
          return throwError(err.message);
        })
      );
  }

}

